export const HotkeyOne = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.583 0C17.5745 0 20 2.42546 20 5.41699V14.583C20 17.5745 17.5745 20 14.583 20H5.41699C2.42546 20 0 17.5745 0 14.583V5.41699C0 2.42546 2.42546 0 5.41699 0H14.583ZM8.38965 6.33008V7.7998H9.33984V13H11.0703V6.33008H8.38965Z"
        fill="#E3E5FA"
      />
    </svg>
  );
};
